import { cn } from 'lib/utils/tailwind'

type DividerProps = {
  className?: string
  orientation?: 'horizontal' | 'vertical'
}

export const Divider = ({
  className,
  orientation = 'horizontal',
}: DividerProps) => {
  return (
    <div
      className={orientation === 'horizontal' ? '' : 'flex flex-col min-h-full'}
    >
      <svg
        width={orientation === 'horizontal' ? '100%' : ''}
        height={orientation === 'vertical' ? '100%' : ''}
        className={cn(
          'stroke-foreground/60',
          orientation === 'horizontal' ? 'h-px' : 'w-px',
          className
        )}
      >
        <line
          x1="0"
          y1="0"
          x2={orientation === 'horizontal' ? '100%' : '0'}
          y2={orientation === 'vertical' ? '100%' : '0'}
          style={{
            strokeWidth: 2,
            strokeDasharray: '2, 5',
          }}
        />
      </svg>
    </div>
  )
}
